import { render, staticRenderFns } from "./product-carousel.vue?vue&type=template&id=0548ee5e&scoped=true&"
import script from "./product-carousel.vue?vue&type=script&lang=js&"
export * from "./product-carousel.vue?vue&type=script&lang=js&"
import style0 from "./product-carousel.vue?vue&type=style&index=0&id=0548ee5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0548ee5e",
  null
  
)

export default component.exports